;(function ( $ ) {

    /**
     *  expandable
     *  hide/show additional rows
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'expandable';
    var defaults = {
        'entriesCollapsed': 3
    };

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            this.entriesCollapsed = $(this.element).data('entries-collapsed');
            if (!this.entriesCollapsed) this.entriesCollapsed = this.settings.entriesCollapsed;
            this.$rows = $(this.element).find('> div');
            $(this.element).addClass('collapsed');
            var _this = this;
            this.$rows.each(function(index) {
                if (index >= _this.entriesCollapsed) {
                    console.log($(this));
                    $(this).hide();
                }
            });
            if (this.$rows.length > this.entriesCollapsed) {
                $(this.element).append('<div class="toggle-row"><a href="#"><span class="icon icon-arrow-down"></span></a></div>');
                $(this.element).parent().find('.tickets-total').css({
                    'border-top': 'none'
                });
            }
            this.registerEvents();
        },
        registerEvents: function() {
            var _this = this;
            $(this.element).find('.toggle-row a').on('click', function(e) {
                e.preventDefault();
                if ($(_this.element).hasClass('collapsed')) {
                    $(_this.element).removeClass('collapsed').addClass('expanded');
                    _this.$rows.show();
                    $(this).find('.icon').removeClass('icon-arrow-down').addClass('icon-arrow-up');
                } else {
                    _this.$rows.each(function(index) {
                        if (index >= _this.entriesCollapsed) {
                            $(this).hide();
                        }
                    });
                    $(_this.element).removeClass('expanded').addClass('collapsed');
                    $(this).find('.icon').removeClass('icon-arrow-up').addClass('icon-arrow-down');
                }
            });
        }
    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
